'use client';

import Image from 'next/image';
import { type JSX, useEffect } from 'react';

import { telemetryClickHandler, telemetryImpressionHandler } from '../telemetryHandler';
import type { NavLink, RichNavItem } from '../types';

interface LayeredMenuItemProps {
    item: RichNavItem;
}

export default function LayeredMenuItem({ item }: LayeredMenuItemProps): JSX.Element {
    useEffect(() => {
        telemetryImpressionHandler(item.telemetrySlug, item.telemetryEvents);
    }, []);

    const link = (
        <a
            href={item.href}
            className="flex items-center gap-3 hover:opacity-80"
            onClick={telemetryClickHandler(item.telemetrySlug, item.telemetryEvents)}
        >
            {(item.stockblocksIcon || item.icon) && (
                <div className="flex size-8 shrink-0 items-center justify-center rounded-sm bg-white shadow-sm">
                    <Image src={item.stockblocksIcon || item.icon!} alt="" width={24} height={24} />
                </div>
            )}
            <div className="flex flex-col gap-0.5">
                <span className="whitespace-nowrap text-base font-semibold text-gray-900">{item.label}</span>
                {item.description && <span className="text-xs text-gray-800 w-[330px]">{item.description}</span>}
            </div>
        </a>
    );

    if (!item.subItems || item.subItems.length === 0) {
        return link;
    }

    return (
        <div className="flex flex-col gap-4">
            {link}
            <div className="flex flex-col gap-4 pl-12">
                {item.subItems.map((subItem) => (
                    <LayeredMenuSubItem key={subItem.href} item={subItem} />
                ))}
            </div>
        </div>
    );
}

function LayeredMenuSubItem({ item }: { item: NavLink }): JSX.Element {
    useEffect(() => {
        telemetryImpressionHandler(item.telemetrySlug, item.telemetryEvents);
    }, []);

    return (
        <a
            href={item.href}
            className="text-sm text-gray-900 hover:opacity-80"
            onClick={telemetryClickHandler(item.telemetrySlug, item.telemetryEvents)}
        >
            {item.label}
        </a>
    );
}
